import React, { useEffect } from "react";
import { useGlobal } from "reactn";
import BoostBillingOverview from "../BoostPremium/BoostBillingOverview";

interface BoostProps {
  setPage: (page: string) => void;
  userSettings: Record<string, unknown>;
}

const Boost: React.FC<BoostProps> = ({ setPage, userSettings }) => {
  const [loggingIn] = useGlobal("loggingIn");

  useEffect(() => {
    setPage("BOOST & Billing");
  }, []);

  if (loggingIn) {
    return (
      <div className="settings-route-page settings_premium">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-route-page settings_premium">
      <BoostBillingOverview userSettings={userSettings} />
    </div>
  );
};

export default Boost;
